module.exports = __webpack_public_path__ + "static/media/Flow-icon-left-chevron-60x60.b483bf06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-icon-left-chevron-60x60.svg
// module id = 4087
// module chunks = 0